import React, { useEffect, useState } from 'react'
import { PageProvider, usePageContext } from './pageContext';
import { useAppContext } from '../../context/appContext';
import { TopBar } from '../../modules/topBar';
import { BottomInfo } from '../../modules/bottomInfo';

export const Page = ({ Component, title="", noBottomInfo, children }) => {
  const { routing } = useAppContext();
  const { route, setRoutes, baseUrl } = routing;

  const pageContext = usePageContext();
  const { index=-1, url=baseUrl } = pageContext || {};

  useEffect(()=>{
    let thisUrl = `${url}/${title}`;
    if (thisUrl.endsWith('/')){
      thisUrl = thisUrl.slice(0, thisUrl.length - 1);
    }

    setRoutes((prev)=>({
      ...prev,
      [thisUrl]: index + 1,
    }));
  },[]);

  return (
    <PageProvider index={index} title={title} url={url}>
      { children }

      <PageComponent Component={Component} noBottomInfo={noBottomInfo} />
    </PageProvider>
  )
}

const PageComponent = ({ Component, noBottomInfo })=>{
  const { title, index, url } = usePageContext();
  const { routing, loadingTime, loading } = useAppContext();
  const { url: currentUrl, routes, baseUrl } = routing;
  const isActive = (url === currentUrl) || (routes[currentUrl] === undefined && title === "not-found");

  const [deRender, setDerender] = useState(false);
  const scrollTop = (delay)=> setTimeout(()=> window.scrollTo({ top: 0, behavior: 'instant' }), delay);

  useEffect(() => {
    if (!isActive) return;
      
    for (let i = 0; i < 15; i++){ // y tho
      scrollTop(i * 50)
    }
    
    // de-render whatever is loaded during navigations
    const listener = () =>{
      setTimeout(()=>{
        setDerender(true);
      },loadingTime / 2);
    }
    
    window.addEventListener("popstate", listener);
    return () =>{
      window.removeEventListener("popstate", listener);
    }
  }, [isActive]);

  useEffect(()=>{
    setDerender(false);
  },[deRender]);
  
  return !deRender && isActive ? (
    <div 
      className={`
        ${title}
        transition-opacity duration-700
        min-h-screen flex flex-col
      `}
      style={{
        opacity: loading ? 0 : 100,
      }}
    > 
      <TopBar />
      <Component />

      {
        !noBottomInfo && (
          <BottomInfo />
        )
      }
      
    </div>
  ) : null
}